import {useQuery} from '@tanstack/react-query'
import {agendaExternaService} from '../services/AgendaExternaService'
import {agendaExternaKeys} from './query-keys'
import type {Identificador} from '../types'

export function useFiliaisQuery() {
  return useQuery({
    queryKey: agendaExternaKeys.filiais(),
    queryFn: async () => {
      const {data} = await agendaExternaService.getFilial()
      return data
    },
  })
}

export function useVolumesFilial(filial: Identificador) {
  const habilitado = Boolean(filial)

  const volumesQuery = useQuery({
    queryKey: agendaExternaKeys.volumes(filial),
    queryFn: async () => {
      const {data} = await agendaExternaService.getVolumes(filial)
      return data
    },
    enabled: habilitado,
  })

  const volumeGeralQuery = useQuery({
    queryKey: agendaExternaKeys.volumeGeral(filial),
    queryFn: async () => {
      const {data} = await agendaExternaService.getVolumeByFilial(filial)
      return data
    },
    enabled: habilitado,
  })

  return {
    eventsData: volumesQuery.data ?? [],
    volumeFinalGeral: volumeGeralQuery.data ?? null,
    isLoading: volumesQuery.isLoading || volumeGeralQuery.isLoading,
    erroVolumes: volumesQuery.error,
    erroVolumeGeral: volumeGeralQuery.error,
  }
}
